module.exports = __webpack_public_path__ + "ota-facility-icon.8086a010de2ac45033e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-facility-icon/fonts/ota-facility-icon.ttf?bot94j
// module id = 1375
// module chunks = 24